import { render } from "./HomepageLive.vue?vue&type=template&id=3642c5d3&scoped=true"
import script from "./HomepageLive.vue?vue&type=script&lang=js"
export * from "./HomepageLive.vue?vue&type=script&lang=js"

import "./HomepageLive.vue?vue&type=style&index=0&id=3642c5d3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3642c5d3"]])

export default __exports__